import router from "@/router";
import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";
import { createApp } from "vue";
import { createPinia } from "pinia";

import { initSentry, captureException } from "@/modules/sentry";
import App from "./App.vue";

import "@/assets/styles.scss";

const app = createApp(App);

initSentry(app, router);

const pinia = createPinia();


app.use(pinia);
app.use(router);

const MyPreset = definePreset(Aura, {
  semantic: {
    select: {
      borderRadius: "{border.radius.lg}",
      height: "2rem",
    },
    formField: {
      borderRadius: "{border.radius.md}",
    },
    primary: {
      50: "{blue.50}",
      100: "{blue.100}",
      200: "{blue.200}",
      300: "{blue.300}",
      400: "{blue.400}",
      500: "{blue.500}",
      600: "{blue.600}",
      700: "{blue.700}",
      800: "{blue.800}",
      900: "{blue.900}",
      950: "{blue.950}",
    },
  },
});
app.use(PrimeVue, {
  theme: {
    preset: MyPreset,
    options: {
      darkModeSelector: ".app-dark",
    },
  },
});
app.use(ToastService);
app.use(ConfirmationService);

// Initialize authentication before mounting the app
// This ensures auth state is ready before any route navigation
async function initializeApp() {
  try {
    const { validateOAuthConfig } = await import(
      "@/service/http/oauthService"
    );
    validateOAuthConfig();

    const { useAuth } = await import("@/stores/auth");
    const authStore = useAuth();

    await authStore.initializeAuth();

    app.mount("#app");
  } catch (error) {
    console.error("❌ Error during app initialization:", error);
    captureException(error instanceof Error ? error : new Error(String(error)), {
      level: "fatal",
      tags: { errorType: "initialization-error" },
    });
    throw error;
  }
}

// Start the app
initializeApp().catch((error) => {
  console.error("💥 Fatal error during initialization:", error);
  captureException(error instanceof Error ? error : new Error(String(error)), {
    level: "fatal",
    tags: { errorType: "initialization-fatal" },
  });
});
